/**
 * Rich Text Editor classes defined here.
 */
/**
 * @hidden
 * @private
 */
export var CLASS_IMAGE_RIGHT = 'e-imgright';
export var CLASS_IMAGE_LEFT = 'e-imgleft';
export var CLASS_IMAGE_CENTER = 'e-imgcenter';
export var CLASS_VIDEO_RIGHT = 'e-video-right';
export var CLASS_VIDEO_LEFT = 'e-video-left';
export var CLASS_VIDEO_CENTER = 'e-video-center';
export var CLASS_IMAGE_BREAK = 'e-imgbreak';
export var CLASS_AUDIO_BREAK = 'e-audio-break';
export var CLASS_VIDEO_BREAK = 'e-video-break';
export var CLASS_CAPTION = 'e-img-caption';
export var CLASS_IMAGE_LEFT_WRAP = 'e-img-left-wrap';
export var CLASS_IMAGE_RIGHT_WRAP = 'e-img-right-wrap';
export var CLASS_RTE_CAPTION = 'e-rte-img-caption';
export var CLASS_CAPTION_INLINE = 'e-caption-inline';
export var CLASS_IMAGE_INLINE = 'e-imginline';
export var CLASS_AUDIO_INLINE = 'e-audio-inline';
export var CLASS_CLICK_ELEM = 'e-clickelem';
export var CLASS_VIDEO_CLICK_ELEM = 'e-video-clickelem';
export var CLASS_AUDIO = 'e-rte-audio';
export var CLASS_VIDEO = 'e-rte-video';
export var CLASS_AUDIO_WRAP = 'e-audio-wrap';
export var CLASS_VIDEO_WRAP = 'e-video-wrap';
export var CLASS_EMBED_VIDEO_WRAP = 'e-embed-video-wrap';
export var CLASS_AUDIO_FOCUS = 'e-audio-focus';
export var CLASS_VIDEO_FOCUS = 'e-video-focus';
export var CLASS_VIDEO_INLINE = 'e-video-inline';
